import { render } from "./MessagePreview.vue?vue&type=template&id=704f7e66"
import script from "./MessagePreview.vue?vue&type=script&lang=js"
export * from "./MessagePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__